<template>
  <form>
  <!-- <form @submit.prevent="onSubmit"> -->
    <div
      class="order-operation-claim-lines-modal modal-card"
      style="width: auto"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">
          <span v-if="claimLine">Edit Claim Line</span>
          <span v-else>Create Claim Line</span>
        </p>
      </header>
      <section class="modal-card-body">
        <base-select
          name="activity_type"
          :service="$options.orderOperationClaimService"
          fetch-func="listCategories"
          :fetch-params="{
            contract_id: order.contract_id,
            asset_id: operation.asset ? operation.asset.id : undefined,
            code_ids: operationCodeIds.length ? operationCodeIds : undefined,
            status: 1,
          }"
          label="Service Type"
          :value.sync="serviceCategory"
          value-key="category"
          label-key="category"
          :fetch-on-init="false"
          ref="selectServiceCategory"
        ></base-select>
        <base-select
          name="service_code"
          :service="$options.orderOperationClaimService"
          fetch-func="all"
          :fetch-params="{
            contract_id: order.contract_id,
            category: serviceCategory,
            include_ids: claimLine ? [claimLine.orderOperationClaimService.id] : undefined,
            asset_id: operation.asset ? operation.asset.id : undefined,
            code_ids: operationCodeIds.length ? operationCodeIds : undefined,
            status: 1,
          }"
          label="Service Code"
          :value.sync="form.serviceCode"
          label-key="ninaCode"
          :fetch-on-init="false"
          @change="option => (rate = option ? option.rate : 0)"
          ref="selectServiceCode"
          v-if="serviceCategory"
        >
          <template #customLabel="{ option }">
            {{ `${option.ninaCode} ${option.description} ${option.status == 0 ? '[ARCHIVED]' : ''}` }}
          </template>
        </base-select>
        <!-- <b-field label="Service Type">
          <b-select
            v-model="serviceCategory"
            name="activity_type"
            expanded
            :disabled="loadingServiceCode"
            :loading="loadingServiceCode"
            ref="selectActivityType"
          >
            <option value>Please Select</option>
            <option
              v-for="activityType in activityTypes"
              :value="activityType"
              :key="activityType"
            >
              {{ activityType }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Service Code">
          <b-select
            v-model="form.serviceCode"
            name="service_code"
            expanded
            :disabled="loadingServiceCode || !serviceCategory"
            :loading="loadingServiceCode"
            ref="selectServiceCode"
          >
            <option value>Please Select</option>
            <option
              v-for="serviceCode in serviceCodesFiltered"
              :value="serviceCode.data.claim_service_id"
              :key="serviceCode.data.claim_service_id"
            >
              {{ serviceCode.code }} {{ serviceCode.name }}
            </option>
          </b-select>
        </b-field> -->
        <b-field grouped>
          <b-field label="Quantity">
            <b-input name="quantity" type="text" v-model="form.quantity"></b-input>
          </b-field>
          <b-field label="Rate" expanded>
            <b-input disabled readonly :value="rate | numberPriceFormatterWithDollarSign"></b-input>
          </b-field>
          <b-field label="Total" expanded>
            <b-input name="total" disabled readonly :value="total | numberPriceFormatterWithDollarSign"></b-input>
          </b-field>
        </b-field>
        <base-select
          name="wbs_code_id"
          :service="$options.codeService"
          :denormalize="false"
          fetch-func="firmFirmCodes"
          :fetch-params="{
            parent_id: order.created_by_firm_id,
            child_id: order.firm_id,
            type: 'CLAIM_LINE_WBS',
            include_ids: claimLine && claimLine.wbsCodeId ? [claimLine.wbsCodeId] : undefined,
            status: 1,
          }"
          :hidden-on-empty="true"
          label="WBS Code"
          :value.sync="form.wbsCodeId"
          label-key="id"
          :fetch-on-init="true"
          @change="option => (code = option ? option.id : null)"
        >
          <template #customLabel="{ option }">
            {{ `${option.code} - ${option.name}` }}
          </template>
        </base-select>
        <b-field label="Notes">
          <b-input name="notes" type="textarea" v-model="form.notes"></b-input>
        </b-field>
      </section>

      <footer class="modal-card-foot">

        <b-button type="is-dark" @click="$parent.close()">CANCEL</b-button>

        <b-button :id="`${claimLine ? 'update' : 'create'}_claim_line`"

        type="is-info" native-type="submit"

        :disabled="buttonStatus"

        :loading="loadingStatus"

        @click.prevent="onSubmit">

          <span v-if="claimLine">UPDATE CLAIM LINE</span>

          <span v-else>CREATE CLAIM LINE</span>

        </b-button>

      </footer>

    </div>

  </form>

</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import { CodeService } from "@/services/code.service";
import { OrderOperationClaimLineService } from "@/services/orderOperationClaimLine.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  codeService: CodeService,
  orderOperationClaimService: OrderOperationClaimServiceService,
  orderOperationClaimLineService: OrderOperationClaimLineService,
  props: {
    order: {
      type: Object,
      required: true
    },
    operation: {
      type: Object,
      required: true
    },
    operationCodeIds: {
      type: Array,
      default: () => ([]),
    },
    claimLine:{
      default: null
    }
  },
  components: {
    BaseSelect
  },
  data: () => ({
    form: {
      serviceCode: "",
      wbsCodeId: "",
      quantity: "",
      notes: ""
    },
    rate: 0,
    // serviceCodes: [],
    serviceCategory: "",
    loading: false,
    // loadingServiceCode: false,
  }),
  computed: {
    // // Service Categories
    // activityTypes() {
    //   let activityTypes = this.serviceCodes.map(sc => sc.group)
    //     .filter(group => group)
    //     .sort();
    //   activityTypes = [...new Set(activityTypes)];
    //   return activityTypes;
    // },
    // serviceCodesFiltered() {
    //   return this.serviceCodes.filter(sc => sc.group === this.serviceCategory);
    // },
    total() {
      return this.rate * (this.form.quantity || 0);
    }
  },
  async mounted() {
    if (this.claimLine) {
      this.form.wbsCodeId = this.claimLine.wbsCodeId;
      this.form.quantity = this.claimLine.quantity;
      this.form.notes = this.claimLine.details;
    }

    await this.$refs.selectServiceCategory.fetchOptions();
    // await this.fetchServiceCodes();

    if (this.claimLine) {
      this.serviceCategory = this.claimLine.orderOperationClaimService.category;

      this.$nextTick(async () => {
        await this.$refs.selectServiceCode.fetchOptions();
        this.form.serviceCode = this.claimLine.orderOperationClaimService.id;
      });
    }
  },
  watch: {
    serviceCategory(val) {
      if (val) {
        this.$nextTick(() => {
          this.rate = 0;
          this.form.serviceCode = "";
          this.$refs.selectServiceCode.reset();
          this.$refs.selectServiceCode.fetchOptions();
        });
      }
      // this.rate = 0;
      // this.form.serviceCode = "";
    },
    // "form.serviceCode"(val) {
    //   const serviceCode = this.serviceCodes.find(sc => sc.data.claim_service_id === val);
    //   this.rate = serviceCode && serviceCode.data && serviceCode.data.rate ? serviceCode.data.rate : 0;
    // },
  },
  methods: {
    transformedData() {
      return {
        orderOperationClaimServiceId: this.form.serviceCode,
        wbsCodeId: this.form.wbsCodeId,
        quantity: this.form.quantity,
        details: this.form.notes
      };
    },
    onInput(key, val) {
      this.form[key] = val;
    },
    onSubmit(event) {

      if (this.claimLine) {

        this.prepareAction('update');
        // this.update();

      } else {

        this.prepareAction('create');
        // this.create();

      }

    },
    // async fetchServiceCodes() {
    //   try {
    //     this.loadingServiceCode = true;
    //     this.serviceCodes = await CodeService.chained({
    //       ids: this.operationCodeIds,
    //       type: "RATE",
    //       contract_id: this.order.contract_id,
    //     })
    //       .then(response => JsonDenormalizer.denormalize(response));
    //   } catch (err) {
    //     throw err;
    //   } finally {
    //     this.loadingServiceCode = false;
    //   }
    // },
    async create() {

      try {
        const claimLine = await this.$options.orderOperationClaimLineService
          .create(this.operation.id, this.transformedData())
          .then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "Claim line has been created.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("create-success", claimLine);
      } catch (err) {}

      this.$parent.close();
    },
    async update() {

      try {
        const claimLine = await this.$options.orderOperationClaimLineService
          .update(this.operation.id, this.claimLine.id, this.transformedData())
          .then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "Claim line has been updated.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("update-success", claimLine);
      } catch (err) {}

      this.$parent.close();
    }
  }
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
.radio-field {
  padding: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderOperationClaimLinesModal.vue